import { createApp } from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import AppLayout from '@/layouts/AppLayout'
import middleware from "@grafikri/vue-middleware"
import'./core';
import i18n from './i18n'
import setupInterceptors from './services/setupInterceptors';

import Maska from 'maska'

setupInterceptors(store);

router.beforeEach(middleware({ store }))

createApp(App).use(i18n)
    .use(store)
    .use(Maska)
    .directive('uppercase', {
        update (el) {
            el.value = el.value.toUpperCase()
        },
        inserted: function(el, _, vnode) {
            el.addEventListener('input', async function(e) {
                e.target.value = e.target.value.toUpperCase()
                vnode.componentInstance.$emit('input', e.target.value.toUpperCase())
            })
        },
        bind(el) {
            el.addEventListener('keyup', () => {
                el.value = el.value.toUpperCase();
            })
        }
    })
    .component('AppLayout', AppLayout)
    .use(router).mount('#app')
